@import "@/scss/use-bootstrap-mixins.scss";

span.header_text {
  color: $primaryOnBackground !important;
  margin: 0 !important;
  font-size: calc(1.3rem + 0.6vw);
  font-weight: 600 !important;
}

.payment_fields {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;

  @include media-breakpoint-up(lg) {
    flex-direction: row;
    gap: 12px;
  }

  .inputs {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    @include media-breakpoint-up(lg) {
      max-width: 60%;
    }

    div {
      flex-basis: 100%;

      &:nth-of-type(1) {
        padding-bottom: 6px;
      }

      &:nth-of-type(2) {
        padding-bottom: 6px;
      }

      &:nth-of-type(3) {
        padding-right: 4px;
      }

      &:nth-of-type(4) {
        padding-left: 4px;
      }

      @include media-breakpoint-up(lg) {
        &:nth-of-type(1) {
          padding-right: 6px;
          padding-bottom: 6px;
        }

        &:nth-of-type(2) {
          padding-left: 6px;
          padding-bottom: 6px;
        }

        &:nth-of-type(3) {
          padding-right: 6px;
          padding-top: 6px;
        }

        &:nth-of-type(4) {
          padding-left: 6px;
          padding-top: 6px;
        }
      }

      .error_label {
        font-size: 12px;
        color: red !important;
        font-style: italic;
      }

      .field_error {
        display: block;
        font-size: 12px;
        color: red !important;
        font-style: italic;
        margin-top: 2px;
      }

      .card_number_wrapper {
        display: flex;
        align-items: center;
        gap: 8px;

        input {
          flex: 1;
          min-width: 0;
        }

        .card_brand_icon {
          display: flex;
          flex-shrink: 0;
          width: 48px;
          height: 32px;

          svg {
            width: 100%;
            height: 100%;
          }
        }
      }

      input {
        border: 1px solid #ccc;
        background-color: #fff !important;
        height: 41px !important;
        padding: 0 15px;
        font-size: 14px;
        border-radius: 4px;

        width: 100%;
      }

      @include media-breakpoint-up(lg) {
        flex-basis: 50%;
      }

      &:nth-of-type(3),
      &:nth-of-type(4) {
        flex-basis: 50%;
      }
    }
  }

  .opt_in {
    display: flex;
    gap: 6px;
    align-items: center;
    align-self: flex-end;

    .custom_checkbox {
      position: relative;
      width: 21px;
      height: 21px;

      label {
        background-color: #fff;
        width: 21px;
        height: 21px;
        border-radius: 11px;
        cursor: pointer;
        position: absolute;
        border: 1px solid #ccc;

        &:after {
          display: initial !important;
          border: 2px solid #fff;
          border-top: none;
          border-right: none;
          content: "";
          height: 6px;
          left: 4px;
          opacity: 0;
          position: absolute;
          top: 6px;
          transform: rotate(-45deg);
          width: 11px;
        }
      }

      input[type="checkbox"] {
        display: none;

        &:checked + label {
          background-color: $primaryOnBackground;
          border-color: $primaryOnBackground;

          &:after {
            opacity: 1;
          }
        }
      }
    }

    span {
    }
  }

  button {
    margin-top: 12px;
    @include media-breakpoint-up(lg) {
      width: 191px !important;
      align-self: flex-end;
      margin-bottom: 4px;
    }
  }
}
